module.exports = __webpack_public_path__ + "static/desktop/img/invitation.537ce2df.svg";